module.exports = __webpack_public_path__ + "static/media/paper.d1b4da0b.jpg";